import "./CategoryTabs.css";

interface CategoryTabsProps {
  sections: { title: string }[];
  activeIndex: number;
  onTabClick: (index: number) => void;
}

export const CategoryTabs = ({
  sections,
  activeIndex,
  onTabClick,
}: CategoryTabsProps) => {
  return (
    <div className="category-tabs">
      <div className="category-tabs__inner">
        {sections.map((section, i) => (
          <button
            key={section.title}
            type="button"
            className={`category-tabs__tab${i === activeIndex ? " category-tabs__tab--active" : ""}`}
            onClick={() => onTabClick(i)}
          >
            {section.title}
          </button>
        ))}
      </div>
    </div>
  );
};
